import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import get from 'lodash/get'
import orderBy from 'lodash/orderBy'
import { authSelector, confidentialSelector, employeeSelector, lobSelector, employeeLevelsSelector } from './../../../selectors'
import { authAction, confidentialAction, employeeAction, lobAction, employeeLevelsAction } from './../../../actions/'
import CustomTableConfidential from '../../../components/table-confidential'

class ListConfidential extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      confidential: [],
      confidential_group: null,
      lob: [],
      level: [],
      employee: [],
      data: [],
      isOK: false,
      sort_by: 'emp_code',
      sort_order: 'desc',
    }
    this.handleClickEdit = this.handleClickEdit.bind(this)
    this.sortBy = this.sortBy.bind(this)
  }

  componentDidMount() {
    const access_token = localStorage.getItem('access_token')
    this.props.getAuth(access_token)
    this.props.listConfidential(access_token)
  }

  componentWillReceiveProps(nextProps) {
    if (get(nextProps, 'lobData')) {
      this.setState({ lob: get(nextProps, 'lobData') })
    }
    if (get(nextProps, 'levelData')) {
      this.setState({ level: get(nextProps, 'levelData') })
    }
    if (get(nextProps, 'employeeData')) {
      this.setState({ employee: get(nextProps, 'employeeData') })
    }
  }

  sortBy(type, order) {
    this.setState({ sort_by: type, sort_order: order ? 'desc' : 'asc' })
  }
  sortConfidential(data) {
    return orderBy(data, [this.state.sort_by], [this.state.sort_order])
  }

  handleClickEdit(id) {
    this.props.handleClickEdit(true, id)
    this.props.handleSpan(true)
  }

  render() {
    const IsSystemUser = get(this.props, 'authData.user.is_system_admin')
    const IsHRConfidentialUser = get(this.props, 'authData.user.is_hr_admin_confidential_role')

    if (get(this.props, 'redirectConfidential.redirect')) {
      localStorage.clear()
      localStorage.setItem('bad_token', true)
      this.props.resetListConfidential()
      window.location = '/'
    }
    if (IsSystemUser !== undefined &&
      IsHRConfidentialUser !== undefined &&
      !(IsSystemUser || IsHRConfidentialUser)) window.location = '/home'

    return (
      /* eslint no-underscore-dangle: 0 */
      <CustomTableConfidential
        sortBy={ this.sortBy }
        data={ this.sortConfidential(this.props.confidential) }
        employee={ this.state.employee }
        handleClickEdit={ this.handleClickEdit }
        span={ get(this.props, 'span') }
      />
    )
  }
}

ListConfidential.propTypes = {
  handleClickEdit: PropTypes.func.isRequired,
  listConfidential: PropTypes.func.isRequired,
  handleSpan: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  confidentialData: confidentialSelector.getListConfidential,
  lobData: lobSelector.getListLOB,
  levelData: employeeLevelsSelector.getListEmployeeLevels,
  employeeData: employeeSelector.getListUser,
  redirectConfidential: confidentialSelector.redirectConfidential,
  authData: authSelector.getAuth,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  listConfidential: confidentialAction.getConfidential,
  listLOB: lobAction.getLOB,
  listLevel: employeeLevelsAction.getEmployeeLevels,
  listEmployee: employeeAction.getUser,
  resetListConfidential: confidentialAction.resetListConfidential,
  getAuth: authAction.auth,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(ListConfidential)



// WEBPACK FOOTER //
// ./src/pages/confidential/list/index.js